import React from "react";
import { X, Share, PlusSquare } from "lucide-react";
import { useInstall } from "@/contexts/InstallContext";

export default function IosInstallHint() {
  const { iosHintOpen, setIosHintOpen } = useInstall();
  if (!iosHintOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center"
      style={{ background: "rgba(0,0,0,0.5)" }}
      onClick={() => setIosHintOpen(false)}
    >
      <div
        className="bg-white rounded-t-3xl sm:rounded-3xl w-full sm:max-w-sm p-6 shadow-2xl"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-slate-900">Install Job Dew</h3>
          <button type="button" onClick={() => setIosHintOpen(false)} className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-slate-500">
            <X className="w-4 h-4" />
          </button>
        </div>
        <ol className="space-y-4 text-sm text-slate-700">
          <li className="flex items-center gap-3">
            <span className="w-8 h-8 shrink-0 rounded-full bg-slate-100 flex items-center justify-center"><Share className="w-4 h-4" /></span>
            Tap the <b>Share</b> icon in Safari's toolbar.
          </li>
          <li className="flex items-center gap-3">
            <span className="w-8 h-8 shrink-0 rounded-full bg-slate-100 flex items-center justify-center"><PlusSquare className="w-4 h-4" /></span>
            Scroll down and tap <b>Add to Home Screen</b>.
          </li>
        </ol>
        <button
          type="button"
          onClick={() => setIosHintOpen(false)}
          className="w-full mt-6 bg-black hover:bg-slate-800 text-white font-semibold py-2.5 rounded-full"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
